export default __webpack_public_path__ + "static/media/expired_wish_list_h5.1f168e63.png";